"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_formatter_1 = require("../../dates/date-formatter");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
function useTranslatedDateFormat(date, alternativeFormat) {
    var currentLanguage = use_translations_hook_1.default().currentLanguage;
    return date_formatter_1.formatDate(date, { language: currentLanguage, alternativeFormat: alternativeFormat });
}
exports.useTranslatedDateFormat = useTranslatedDateFormat;
function useTranslatedDateTimeFormat(dateTime, alternativeFormat) {
    var currentLanguage = use_translations_hook_1.default().currentLanguage;
    return date_formatter_1.formatDateTime(dateTime, { language: currentLanguage, alternativeFormat: alternativeFormat });
}
exports.useTranslatedDateTimeFormat = useTranslatedDateTimeFormat;
//# sourceMappingURL=use-translated-date.hook.js.map